<app-accordion
  class="my-1"
  [title]="'Vale Alimentação e Refeição'"
  *ngIf="benefit"
>
  <div class="w-100">
    <div class="row mt-3">
      <!-- <label class="text-default-label">{{ benefit.alias }}</label> -->
      <label class="text-default-label">Vale Alimentação e Refeição</label>
      <div class="w-100 row mx-0 align-items-end">
        <label class="cred-text">Distribuição de Créditos</label>
        <div class="col-md-12 px-0">
          <ng-select
            [items]="benefit.items"
            bindLabel="name"
            placeholder="Selecione uma opção"
            [(ngModel)]="selectedPlan"
            (clear)="removeSelectedPlan()"
            (change)="onOptionSelected($event)"
          ></ng-select>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md-2 col-12 col-sale">
          <label class="text-sale">VA/Mensal</label>
          <span>
            {{ selectedVaMonthly?.va | currency : "BRL" : "symbol" }}</span
          >
        </div>
        <div class="col-md-4 col-12 col-value">
          <label class="text-valuedesc">VR/Mensal</label>
          <span>{{ selectedVaMonthly?.vr | currency : "BRL" : "symbol" }}</span>
        </div>
        <div class="col-md-4 col-12 col-benefic">
          <label class="text-benefictransp">Total</label>
          <span>{{
            selectedVaMonthly?.vr + selectedVaMonthly?.va
              | currency : "BRL" : "symbol"
          }}</span>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md-3 col-12 col-sale">
          <label class="text-sale">Desconto do titular</label>
          <span>{{ selectedPlan?.existDiscountToHolder }}</span>
        </div>
        <div class="col-md-4 col-12 col-value">
          <label class="text-valuedesc">Valor ou % do desconto</label>
          <span>R$ {{ selectedPlan?.holderDiscount }}</span>
        </div>
      </div>
    </div>
  </div>
</app-accordion>
